import React, { useEffect, useRef, useState } from "react";
import MolGrid from "../../components/Grid/MolGrid";
import { BoardApprovalUpdateConfig } from "./component/BoardApprovalUpdateConfig";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import Buttons from "../../components/ui/button/Buttons";
import { useApproveCorporateApplicationMutation, useCorporateApplicationRejectByBordApprovalMutation, useCreateInvoiceMutation, useLazyCorporateBoardApprovalUpdateQuery } from "../../app/services/CorporateMembershipTaskList/corporateMembershipTaskListApi";
import { encryptAESID } from "../../utils/Encryption";
import SwalAlert from "../../services/swalService/SwalService";

const BoardApprovalUpdate = () => {
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState();
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [poNumber, setPoNumber] = useState("");
  const [rejectComments, setRejectComments] = useState("");
  const [corporateMemberId, setCorporateMemberId] = useState(null)
  const [membershipTypeId, setMembershipTypeId] = useState(null)
  const { error, success, confirm } = SwalAlert();
  const [corporateBoardApprovalUpdate, { isSuccess: isSuccessCorporateBoardApprovalUpdate, isLoading: isLoadingCorporateBoardApprovalUpdate, data: getCorporateBoardApprovalUpdateResponse, },] = useLazyCorporateBoardApprovalUpdateQuery();
  const [createInvoice, { isSuccess: isSuccessCreateInvoice, isLoading: isLoadingCreateInvoice, data: getCreateInvoiceResponse, },] = useCreateInvoiceMutation();
  const [approveCorporateApplication, { isSuccess: isSuccessApproveCorporateApplication, isLoading: isLoadingApproveCorporateApplication, data: getApproveCorporateApplicationResponse, },] = useApproveCorporateApplicationMutation();
  const [corporateApplicationRejectByBordApproval, { isSuccess: isSuccessCorporateApplicationRejectByBordApproval, isLoading: isLoadingCorporateApplicationRejectByBordApproval, data: getCorporateApplicationRejectByBordApprovalResponse, },] = useCorporateApplicationRejectByBordApprovalMutation();

  useEffect(() => {
    corporateBoardApprovalUpdate();
  }, []);

  useEffect(() => {
    if (!isLoadingApproveCorporateApplication && isSuccessApproveCorporateApplication && getApproveCorporateApplicationResponse) {
      success("Information has been sent to Xero.");
      closeAcceptModal();
      setPoNumber("");
      corporateBoardApprovalUpdate();
    }
  }, [isLoadingApproveCorporateApplication, isSuccessApproveCorporateApplication, getApproveCorporateApplicationResponse,]);

  useEffect(() => {
    if (!isLoadingCorporateBoardApprovalUpdate && isSuccessCorporateBoardApprovalUpdate && getCorporateBoardApprovalUpdateResponse) {
      const boardApprovalUpdate = getCorporateBoardApprovalUpdateResponse?.map(
        (companyName) => ({
          ...companyName,
          membershipTaskListLink: `/memberapplicationtasklistdetailform/${encodeURIComponent(encryptAESID(companyName?.sgbcCorporateMemberId))}/${encodeURIComponent(encryptAESID(companyName?.membershipApplicationTaskListId))}`,
        })
      );
      setDataSource(boardApprovalUpdate);
    }
  }, [isLoadingCorporateBoardApprovalUpdate, isSuccessCorporateBoardApprovalUpdate, getCorporateBoardApprovalUpdateResponse,]);

  useEffect(() => {
    if (!isLoadingCorporateApplicationRejectByBordApproval && isSuccessCorporateApplicationRejectByBordApproval && getCorporateApplicationRejectByBordApprovalResponse) {
      success("Application Rejected !");
      closeRejectModal();
      setRejectComments("");
      corporateBoardApprovalUpdate();
    }
  }, [isLoadingCorporateApplicationRejectByBordApproval, isSuccessCorporateApplicationRejectByBordApproval, getCorporateApplicationRejectByBordApprovalResponse,]);

  const closeAcceptModal = () => {
    setShowAcceptModal(false);
    setCorporateMemberId(null)
    setMembershipTypeId(null)
    setPoNumber("");
  }

  const closeRejectModal = () => {
    setShowRejectModal(false);
    setCorporateMemberId(null)
    setMembershipTypeId(null)
    setPoNumber("");
    setRejectComments("");
  }

  const handleRejectApplication = (data) => {
    setShowRejectModal(true);
    setCorporateMemberId(data?.sgbcCorporateMemberId)
  }

  const handleAcceptApplication = (data) => {
    setShowAcceptModal(true);
    setCorporateMemberId(data?.sgbcCorporateMemberId)
    setMembershipTypeId(data?.membershipPaymentTypeId)
  }

  const actionHandler = {
    Accept: handleAcceptApplication,
    Reject: handleRejectApplication
  };

  const onRejectClick = () => {
    let req = {
      SGBCCorporateMemberId: corporateMemberId,
      RejectedNote: rejectComments
    };
    confirm('Reject', "Are you sure you want to reject this application?", 'Yes', 'Cancel')
      .then(id => {
        if (id) {
          corporateApplicationRejectByBordApproval(req);
        } else {
          closeRejectModal();
          setRejectComments("");
        }
      })

  }
  useEffect(() => {
    if (isSuccessCreateInvoice && getCreateInvoiceResponse) {
      if (getCreateInvoiceResponse.hasErrors === false) {
        approveCorporateApplication({
          SGBCCorporateMemberId: corporateMemberId,
          PONumber: poNumber,
        });
      }
      else {
        error("Failed to create invoice in Xero. Please try again.")
      }
    }
  }, [getCreateInvoiceResponse])

  const onApproveClick = () => {
    createInvoice({
      MemberId: corporateMemberId,
      MembershipType: membershipTypeId,
      PoNumber: poNumber,
    });
  };

  return (
    <div className="board-approval-update">
      <div className="board-approval-grid">
        <MolGrid
          ref={molGridRef}
          configuration={BoardApprovalUpdateConfig}
          dataSource={dataSource}
          allowPagination={false}
          onActionChange={actionHandler}
        />
      </div>
      <CenterModel
        show={showAcceptModal}
        handleClose={closeAcceptModal}
        modelTitle="Invoice information will be pushed to Xero "
      >
        <p className="">Please enter a PO number, if applicable</p>
        <input
          type="text"
          className="form-control mt-2"
          placeholder=""
          value={poNumber}
          onChange={(e) => setPoNumber(e.target.value)}
        />

        <div className="d-flex justify-content-between gap-2 mt-4">
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="black-btn"
            onClick={closeAcceptModal}
          />
          <Buttons
            buttonText="Proceed"
            buttonTypeClassName="success-btn"
            value={poNumber}
            onClick={onApproveClick}
            isLoading={isLoadingApproveCorporateApplication || isLoadingCreateInvoice}
            isDisable={isLoadingApproveCorporateApplication || isLoadingCreateInvoice}
          />
        </div>
      </CenterModel>
      <CenterModel
        show={showRejectModal}
        handleClose={closeRejectModal}
        modelTitle=""
      >
        <p>
        Enter Rejection Reason which would be displayed in the rejection email sent to the Applicant.
        </p>
        <textarea
          className="form-control mt-2"
          rows="3"
          placeholder=""
          value={rejectComments}
          onChange={(e) => setRejectComments(e.target.value)}
        />

        <div className="d-flex justify-content-between gap-2 mt-4">
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="black-btn"
            onClick={closeRejectModal}
          />
          <Buttons
            buttonText="Proceed"
            buttonTypeClassName="success-btn"
            value={rejectComments}
            onClick={onRejectClick}
            isLoading={isLoadingCorporateApplicationRejectByBordApproval}
            isDisable={isLoadingCorporateApplicationRejectByBordApproval}
          />
        </div>
      </CenterModel>
    </div>
  );
};
export default BoardApprovalUpdate;
